import { FadeUp } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, sub }) {
  return (
    <section className="relative overflow-hidden bg-navy">
      <div className="absolute inset-0 bg-grid-dark" aria-hidden="true" />
      <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-safety/20 blur-3xl" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-6 py-16 lg:py-24">
        <FadeUp>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-rose-300">{eyebrow}</p>
          <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            {title}
          </h1>
          {sub && <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/60">{sub}</p>}
        </FadeUp>
      </div>
    </section>
  );
}
